// V3 shared visual system: one accent hue per capability/category so the preview
// reads as a designed product (color + diagram + depth) instead of a flat mono document.

export const CAPABILITY_THEME = {
  website: { hue: "#38bdf8", soft: "rgba(56,189,248,0.16)", label: "WEBSITE" },
  webdev: { hue: "#818cf8", soft: "rgba(129,140,248,0.16)", label: "WEB DEVELOPMENT" },
  saas: { hue: "#a78bfa", soft: "rgba(167,139,250,0.16)", label: "SAAS / PLATFORM" },
  admin: { hue: "#f59e0b", soft: "rgba(245,158,11,0.16)", label: "ADMIN / BUSINESS SYSTEM" },
  ai: { hue: "#f472b6", soft: "rgba(244,114,182,0.16)", label: "AI" },
  automation: { hue: "#34d399", soft: "rgba(52,211,153,0.16)", label: "AUTOMATION" },
  search: { hue: "#60a5fa", soft: "rgba(96,165,250,0.16)", label: "SEARCH TECHNOLOGY" },
};

export const CATEGORY_THEME = {
  homepage: { hue: "#38bdf8" },
  hospital: { hue: "#fb7185" },
  industry: { hue: "#fb7185" },
  platform: { hue: "#818cf8" },
  ai: { hue: "#f472b6" },
  saas: { hue: "#a78bfa" },
  search: { hue: "#60a5fa" },
};

export function themeOf(id) {
  return CAPABILITY_THEME[id] || { hue: "#94a3b8", soft: "rgba(148,163,184,0.16)", label: id || "" };
}

export function categoryHue(id) {
  return (CATEGORY_THEME[id] || {}).hue || "#94a3b8";
}

export const CAPABILITY_ORDER = ["website", "webdev", "saas", "admin", "ai", "automation", "search"];
